import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { Parte } from "../../../shared/types";
import { EncabezadoPagina } from "../../components/EncabezadoPagina";
import { CampoBusqueda } from "../../components/Formulario";
import { Tabla, type ColumnaTabla } from "../../components/Tabla";
import { useToast } from "../../components/Toast";
import { api } from "../../lib/apiClient";

type ParteConExpediente = Parte & { numero_expediente: string };

export function PartesPage() {
  const { mostrar } = useToast();
  const [partes, setPartes] = useState<ParteConExpediente[]>([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    api
      .get<{ items: ParteConExpediente[] }>("/partes")
      .then((d) => setPartes(d.items))
      .catch(() => mostrar("No se pudieron cargar las partes.", "error"))
      .finally(() => setCargando(false));
  }, [mostrar]);

  const filtradas = partes.filter((p) =>
    `${p.nombre_completo} ${p.numero_expediente} ${p.rol}`
      .toLowerCase()
      .includes(busqueda.toLowerCase()),
  );

  const columnas: ColumnaTabla<ParteConExpediente>[] = [
    { encabezado: "Nombre", render: (p) => p.nombre_completo },
    { encabezado: "Rol", render: (p) => p.rol },
    { encabezado: "Documento", render: (p) => p.documento ?? "—" },
    {
      encabezado: "Expediente",
      render: (p) => (
        <Link
          to={`/expedientes/${p.expediente_id}`}
          className="font-medium text-texto transition-colors hover:text-secundario hover:underline"
        >
          {p.numero_expediente}
        </Link>
      ),
    },
  ];

  return (
    <div>
      <EncabezadoPagina
        titulo="Partes"
        descripcion="Contrapartes, testigos y demás involucrados en los expedientes. Se agregan desde la ficha de cada expediente."
      />
      <div className="mb-4">
        <CampoBusqueda
          valor={busqueda}
          onCambio={setBusqueda}
          placeholder="Buscar por nombre o expediente..."
        />
      </div>
      <Tabla
        columnas={columnas}
        filas={filtradas}
        claveFila={(p) => p.id}
        cargando={cargando}
        tituloVacio="No hay partes registradas"
        descripcionVacio="Agregá partes desde la pestaña 'Partes' de un expediente."
      />
    </div>
  );
}
